import Bugsnag from '@bugsnag/js'

// Diagnostic middleware for the long-standing "project opens with all
// milestones but no tasks" bug. Snapshots every milestone's task list length
// before/after each action and reports any action that shrinks or removes
// one, so the real repro tells us exactly which action wiped the lists.
// Cheap enough to leave on in production; remove once the bug is dead.

const snapshotTaskCounts = state => {
	const milestones = state.account && state.account.entities && state.account.entities.milestones

	const counts = {}

	if (milestones) {
		for (const id in milestones) {
			const milestone = milestones[id]

			if (milestone && Array.isArray(milestone.tasks)) {
				counts[id] = milestone.tasks.length
			}
		}
	}

	return counts
}

export const taskWatchdog = store => next => action => {
	const before = snapshotTaskCounts(store.getState())

	const result = next(action)

	const after = snapshotTaskCounts(store.getState())

	const shrunk = []

	for (const id in before) {
		if (typeof after[id] === 'undefined' || after[id] < before[id]) {
			shrunk.push({
				milestoneId: id,
				before: before[id],
				after: typeof after[id] === 'undefined' ? 'gone' : after[id]
			})
		}
	}

	if (shrunk.length) {
		const info = {
			actionType: action.type,
			entityType: action.entityType,
			hardSetAll: !!action.hardSetAll,
			overwriteTasks: !!action.overwriteTasks,
			overwriteUsers: !!action.overwriteUsers,
			isArray: !!action.isArray,
			milestonesAffected: shrunk.length,
			shrunk: shrunk.slice(0, 20),
			url: window.location.pathname,
			at: new Date().toISOString()
		}

		console.warn('[TaskWatchdog] milestone task lists shrank', info)

		window.__taskWatchdogLog = (window.__taskWatchdogLog || []).concat(info).slice(-50)

		try {
			Bugsnag.notify(new Error('TaskWatchdog: milestone task lists shrank via ' + action.type), event => {
				event.severity = 'info'
				event.groupingHash = 'task-watchdog-' + action.type + '-' + (action.entityType || '')
				event.addMetadata('watchdog', info)
			})
		} catch (e) {
			// never let diagnostics break the app
		}
	}

	return result
}

// For the *fill* path — the new-tab/notification flow leaves milestones with
// only the one persisted task and never grows them, so it's an under-fill, not
// a shrink, and the middleware above can't see it. These probes log every time
// (no Bugsnag — a normal project open hits them constantly) so we can watch
// whether getProject returns full task lists and whether PROJECT_GOT_DATA
// actually writes them into the milestones.
export const reportFillPath = (name, info) => {
	const entry = {
		name,
		...info,
		url: window.location.pathname,
		at: new Date().toISOString()
	}

	console.log('[TaskWatchdog:fill] ' + name, entry)

	window.__taskWatchdogLog = (window.__taskWatchdogLog || []).concat(entry).slice(-50)
}

// For the silent one-off paths (reducer discard, skipped fetches) that aren't
// state shrinks but leave the project permanently task-less.
export const reportSilentPath = (name, info) => {
	const entry = {
		name,
		...info,
		url: window.location.pathname,
		at: new Date().toISOString()
	}

	console.warn('[TaskWatchdog] ' + name, entry)

	window.__taskWatchdogLog = (window.__taskWatchdogLog || []).concat(entry).slice(-50)

	try {
		Bugsnag.notify(new Error('TaskWatchdog: ' + name), event => {
			event.severity = 'info'
			event.groupingHash = 'task-watchdog-' + name
			event.addMetadata('watchdog', entry)
		})
	} catch (e) {
		// never let diagnostics break the app
	}
}
